import {
  buildCloneSparklineColumns,
  type CloneSparklineColumns,
} from '@/features/shared/components/cloneTable/cloneSparklineColumns';
import type { MetricThresholdGroup, SuiteListItemDto } from '@flowqa/shared';

type BuildSuitesSparklineColumnsArgs = {
  passRateAsSparklineCell: boolean;
  frequencyAsSparklineCell: boolean;
  avgDurationAsSparklineCell: boolean;
  showDeltas: boolean;
  resolvedThresholds: (row: SuiteListItemDto) => MetricThresholdGroup;
  metricSeriesBySuiteId?: Map<
    string,
    {
      dates: Date[];
      passRate: number[];
      frequencyPerDay: number[];
      averageDurationMs: number[];
    }
  >;
  columnFlex: {
    passRate: number;
    frequency: number;
    avgDuration: number;
  };
};

type SparklineColumns = CloneSparklineColumns<SuiteListItemDto>;

const cellClassNames = {
  passRate: 'tests-table-clone-passrate-cell',
  frequency: 'tests-table-clone-frequency-cell',
  avgDuration: 'tests-table-clone-avgduration-cell',
} as const;

export const buildSuitesSparklineColumns = ({
  passRateAsSparklineCell,
  frequencyAsSparklineCell,
  avgDurationAsSparklineCell,
  showDeltas,
  resolvedThresholds,
  metricSeriesBySuiteId,
  columnFlex,
}: BuildSuitesSparklineColumnsArgs): SparklineColumns => {
  return buildCloneSparklineColumns<SuiteListItemDto>({
    passRateAsSparklineCell,
    frequencyAsSparklineCell,
    avgDurationAsSparklineCell,
    showDeltas,
    resolvedThresholds,
    metricSeriesById: metricSeriesBySuiteId,
    columnFlex,
    cellClassNames,
  });
};
